<template>
  <div class="product-info">
    <img class="corner top" src="@/assets/arrow-black.svg" alt />

    <h1>{{ product.name }}</h1>
    <div v-if="description" class="description" v-html="description">
      {{ description }}
    </div>

    <h3 v-if="product.restoredIn">{{ product.restoredIn }}</h3>
    <p v-if="product.price" class="price">{{ product.price }} kr</p>
    <span class="sold" v-if="product.sold">SOLD</span>

    <a v-else :href="product.buyLink">
      <button class="buy">Buy</button>
    </a>

    <img class="corner bottom" src="@/assets/arrow-black.svg" alt />
  </div>
</template>

<script>
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";

export default {
  name: "ProductInfo",

  props: {
    product: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    description() {
      return documentToHtmlString(this.product.description);
    },
  },
};
</script>

<style lang="scss" scoped>
$info-right: $menu-width + $space-base + $space-base;
$info-right-small: $menu-width + $space-small + $space-small;
$info-left-small: $logo-width-small + $space-small;

.product-info {
  font-size: 0.725rem;
  position: absolute;
  text-align: center;
  top: $space-small;
  left: $info-left-small;
  right: $info-right-small;
  padding: $space-base;

  @include large {
    top: $space-base;
    left: auto;
    right: $info-right;
    width: calc(45% - #{$info-right} - #{$space-base});
  }

  h1,
  h2 {
    font-weight: bold;
    margin: 0 0 4px 0;
    font-size: 1.1rem;
    color: white;
  }

  h3 {
    margin-top: $space-small;
  }

  .description {
    margin-top: $space-base;

    /deep/ p {
      margin: 0;
      font-family: "SkalanFontSecond";
    }
  }

  .price {
    font-family: "SkalanFontSecond";
  }

  .sold {
    background: $orange;
    border-radius: 1px;
    color: black;
    text-transform: uppercase;
    font-family: "SkalanFontSecond";
    font-size: 0.775rem;
    padding: 4px 10px;
  }

  .buy {
    background: black;
    border-radius: 1px;
    border: 0;
    color: white;
    text-transform: uppercase;
    font-family: "SkalanFontSecond";
    font-size: 0.775rem;
    padding: 4px 10px;

    &:hover {
      color: black;
      background: orangered;
    }
  }

  .corner {
    position: absolute;
    width: 30px;
    height: 30px;

    &.top {
      top: 0;
      right: 0;
      transform: rotate(135deg);
    }

    &.bottom {
      bottom: 0;
      left: 0;
      transform: rotate(-45deg);
    }
  }
}
</style>